/**
 * 学習パスの名前に「学習パス」を付けた題。名前が既に「パス」で終わるとき (学習前の準備パス、FDE&ITコンサル学習パス など) は足さない。
 * 足すと「学習前の準備パス学習パス」と重なる (10/19 代表)。今の本番のコースの名前 (「パス」で終わらない) では、前と同じ題になる
 */
export function learningPathTitle(name: string): string {
  return /パス$/.test(name.trim()) ? name : `${name}学習パス`;
}
